import {
  ChangeDetectorRef,
  Component,
  NgZone,
  ViewChild,
  OnInit,
} from '@angular/core';
// import Swiper core and required modules
import SwiperCore, { SwiperOptions, Navigation, Virtual } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
SwiperCore.use([Navigation, Virtual]);
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-dashboard-app',
  templateUrl: './dashboard-app.component.html',
  styleUrls: ['./dashboard-app.component.scss'],
})
export class DashboardAppComponent implements OnInit {
  @ViewChild('swiperRef', { static: false })
  sliderRef?: SwiperComponent;
  apps: Array<any> = [
    // { name: 'Type Approval', description: 'Type Approval Application and Request for Permit' },
    // { name: 'Spectrum', description: 'License Application Renewal & Submission' },
    // { name: 'Numbering Management', description: 'License Application Renewal' }
    // { name: 'Economic Analysis and ', description: 'Operator Questionaires, Tarriff Managment' }
  ];
  config: SwiperOptions = {
    slidesPerView: 3,
    spaceBetween: 10,
    virtual: true,
  };
  onSwiper(swiper) {
    console.log(swiper);
    // swiper.update();
  }

  colors = ['#DFF4EB', '#DCF0EB', '#F0EECC', '#F1E6DB', '#F8EBFC'];
  organizationId: string;
  user: any;
  token: string;
  baseUrl = environment.API_SERVER;
  constructor(private cd: ChangeDetectorRef, private ngZone: NgZone) {
    this.user = JSON.parse(window.localStorage.getItem('user'));
    if (this.user) {
      // this.organizationId = JSON.parse(window.localStorage.getItem('userData'))['appUser'].appUserId;
      this.organizationId = this.user.appUserId;
      this.token = window.localStorage.getItem('jwt');
      let apps: Array<any> = [];
      this.apps = [];
      this.user['applications'].forEach((app) => {
        app['applicationHost'] =
          app['applicationHost'] + '?token=' + this.token;
        apps.push(app);
      });
      this.apps = apps;

      console.log('apps ', this.apps);

      this.apps.map((app) => {
        app.color = this.generateColors();
      });

      this.apps = apps;

      // this.cd.markForCheck();
    }
  }

  generateColors() {
    let color = this.colors[Math.floor(Math.random() * this.colors.length)];
    return color;
    // console.log('#000000'.slice(0, -color.length) + color);
    // return '#000000'.slice(0, -color.length) + color;
  }
  ngOnInit() {}
  slideNext() {
    this.sliderRef.swiperRef.slideNext(100);
  }
  slidePrev() {
    this.sliderRef.swiperRef.slidePrev(100);
  }
  onSlideChange() {}
  checkPermission(permissionId: string, action: string): boolean {
    try {
      const storedPermissions = localStorage.getItem('permissions');
      if (!storedPermissions) return false;

      const permissions = JSON.parse(storedPermissions);
      const perm = permissions.find(
        (p: any) => p.permissionId === permissionId
      );

      return perm && perm[action] === 'true';
    } catch {
      return false;
    }
  }
}
